var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiantMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70555 12.1748C8.74201 12.186 8.78099 12.186 8.81745 12.1748C8.84654 12.1842 8.87787 12.1842 8.90696 12.1748L20.1747 5.68498C20.7658 5.41945 21.4065 5.28216 22.0545 5.28216C22.7025 5.28216 23.3432 5.41945 23.9343 5.68498L35.1908 12.186C35.2199 12.2078 35.2552 12.2196 35.2915 12.2196C35.3279 12.2196 35.3632 12.2078 35.3923 12.186L39.4764 8.8292C39.4883 8.80479 39.4944 8.77801 39.4944 8.75087C39.4944 8.72373 39.4883 8.69695 39.4764 8.67255C39.4751 8.64551 39.4673 8.61917 39.4537 8.59579C39.4401 8.57241 39.421 8.55268 39.3981 8.53827L26.5638 1.11971C25.1938 0.365944 23.6516 -0.0195875 22.0881 0.000766088C20.5247 -0.0175523 18.9831 0.367852 17.6123 1.11971L4.6438 8.56065C4.61995 8.5751 4.59957 8.59462 4.5841 8.61783C4.56863 8.64103 4.55845 8.66735 4.55429 8.69492C4.55341 8.72272 4.55902 8.75034 4.57068 8.77558C4.58233 8.80083 4.59971 8.82302 4.62142 8.84039L8.70555 12.1748Z",
    fill: "url(#paint0_linear_667_1030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3883 17.7583C28.4061 17.7657 28.4251 17.7695 28.4443 17.7695C28.4635 17.7695 28.4825 17.7657 28.5002 17.7583L32.2934 14.6364C32.3298 14.5968 32.3498 14.5448 32.3494 14.491C32.3481 14.4639 32.3403 14.4376 32.3267 14.4142C32.3131 14.3908 32.294 14.3711 32.2711 14.3567L24.3266 9.8138C23.6208 9.44973 22.8381 9.25977 22.044 9.25977C21.2498 9.25977 20.4671 9.44973 19.7613 9.8138L11.8057 14.3567C11.7827 14.3711 11.7637 14.3908 11.75 14.4142C11.7364 14.4376 11.7286 14.4639 11.7273 14.491C11.7219 14.518 11.7243 14.5461 11.7342 14.5718C11.7441 14.5976 11.7611 14.62 11.7833 14.6364L15.5989 17.7135C15.6279 17.7353 15.6633 17.7471 15.6996 17.7471C15.7359 17.7471 15.7712 17.7353 15.8003 17.7135L21.9544 14.2C21.9834 14.1833 22.0162 14.1746 22.0495 14.1746C22.0829 14.1746 22.1157 14.1833 22.1447 14.2L28.2988 17.7247L28.3883 17.7583Z",
    fill: "url(#paint1_linear_667_1030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7471 25.3895L21.9878 27.84H22.0773H22.1669L26.3405 25.4231C26.368 25.4072 26.3907 25.3844 26.4064 25.3568C26.4222 25.3293 26.4303 25.2981 26.43 25.2664V20.4438C26.4303 20.4121 26.4222 20.3809 26.4064 20.3534C26.3907 20.3258 26.368 20.303 26.3405 20.2871L22.2228 17.9038C22.196 17.8869 22.165 17.8779 22.1333 17.8779C22.1016 17.8779 22.0706 17.8869 22.0438 17.9038L18.5639 19.9067L17.8813 20.2424C17.85 20.2543 17.8233 20.2759 17.8052 20.3041C17.787 20.3323 17.7784 20.3656 17.7806 20.399V23.9125L17.7247 25.2552C17.7181 25.2778 17.7166 25.3017 17.7205 25.3249C17.7244 25.3482 17.7335 25.3702 17.7471 25.3895Z",
    fill: "url(#paint2_linear_667_1030)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.396 45.005C19.527 45.5763 20.7765 45.874 22.0437 45.874C23.3109 45.874 24.5604 45.5763 25.6914 45.005C26.3069 44.6693 38.6152 37.62 38.6152 37.62C39.9675 36.8047 41.0888 35.657 41.8722 34.286C42.6556 32.915 43.0752 31.3664 43.091 29.7874V14.9167C43.0897 14.8881 43.082 14.8602 43.0684 14.835C43.0548 14.8098 43.0358 14.788 43.0126 14.7712C42.988 14.7601 42.9613 14.7544 42.9343 14.7544C42.9073 14.7544 42.8806 14.7601 42.856 14.7712L37.9215 16.6399C37.9057 16.6603 37.8946 16.6838 37.8888 16.7089C37.883 16.734 37.8827 16.7601 37.8879 16.7853C37.8879 16.7853 37.8879 29.6755 37.8879 30.0112C37.7921 30.6194 37.5767 31.2025 37.254 31.7269C36.9313 32.2512 36.5079 32.7063 36.0081 33.0659L23.9347 40.0145C23.3417 40.2803 22.6992 40.4177 22.0493 40.4177C21.3994 40.4177 20.7569 40.2803 20.1639 40.0145L8.1241 33.0659C7.62432 32.7063 7.20083 32.2512 6.87815 31.7269C6.55548 31.2025 6.34003 30.6194 6.24428 30.0112C6.17715 29.6755 6.24428 16.7853 6.24428 16.7853C6.24396 16.7509 6.23305 16.7174 6.21303 16.6894C6.19301 16.6613 6.16486 16.6401 6.13239 16.6287L1.19787 14.76C1.17325 14.7489 1.14655 14.7432 1.11954 14.7432C1.09253 14.7432 1.06583 14.7489 1.04122 14.76C1.01806 14.7768 0.998998 14.7986 0.985437 14.8238C0.971876 14.849 0.96417 14.8769 0.962891 14.9055L0.962891 29.8098C0.978666 31.3887 1.39823 32.9374 2.18166 34.3084C2.96509 35.6794 4.08631 36.8271 5.43865 37.6423C5.43865 37.6423 17.6798 44.6357 18.396 45.005Z",
    fill: "url(#paint3_linear_667_1030)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8618 35.9409C20.5372 36.2851 21.2856 36.4617 22.0437 36.4556C22.7988 36.4671 23.5449 36.2902 24.2144 35.9409L32.2932 31.3309C32.9959 30.9595 33.5791 30.3966 33.9752 29.7075C34.3712 29.0184 34.564 28.2311 34.5311 27.437V18.3288C34.5298 18.3002 34.5221 18.2723 34.5085 18.2471C34.495 18.2219 34.4759 18.2001 34.4527 18.1833C34.4281 18.1722 34.4014 18.1665 34.3744 18.1665C34.3474 18.1665 34.3207 18.1722 34.2961 18.1833L29.6861 19.9065C29.6536 19.918 29.6254 19.9392 29.6054 19.9672C29.5854 19.9952 29.5745 20.0287 29.5742 20.0632V27.1125C29.5766 27.1402 29.5704 27.168 29.5564 27.1921C29.5424 27.2162 29.5212 27.2353 29.4958 27.2467L22.0101 31.4651C21.9416 31.4909 21.8661 31.4909 21.7975 31.4651L14.4237 27.2467C14.3984 27.2353 14.3772 27.2162 14.3632 27.1921C14.3491 27.168 14.3429 27.1402 14.3454 27.1125V20.0632C14.3451 20.0287 14.3342 19.9952 14.3141 19.9672C14.2941 19.9392 14.266 19.918 14.2335 19.9065L9.71299 18.1721C9.68838 18.161 9.66168 18.1553 9.63467 18.1553C9.60766 18.1553 9.58096 18.161 9.55634 18.1721C9.53319 18.1889 9.51412 18.2107 9.50056 18.2359C9.487 18.2611 9.4793 18.289 9.47802 18.3176V27.4146C9.44376 28.209 9.63593 28.9968 10.0321 29.6862C10.4283 30.3755 11.0123 30.9382 11.7159 31.3085L19.8618 35.9409Z",
    fill: "url(#paint4_linear_667_1030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_1030",
    x1: 4.55429,
    y1: 6.11017,
    x2: 39.5323,
    y2: 6.11017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_1030",
    x1: 210.136,
    y1: 111.972,
    x2: 590.666,
    y2: 111.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_667_1030",
    x1: 147.783,
    y1: 221.402,
    x2: 215.995,
    y2: 221.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_667_1030",
    x1: 0.962891,
    y1: 30.3133,
    x2: 43.1357,
    y2: 30.3133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A6B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#535455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_667_1030",
    x1: 200.185,
    y1: 464.88,
    x2: 763.296,
    y2: 464.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#28B24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#28B24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiantMobileLogo);
export default __webpack_public_path__ + "static/media/GiantMobileLogo.5f35a787075b98b29d393e60cf182ffa.svg";
export { ForwardRef as ReactComponent };